// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.js?" + "8cb2b1a17e0010e2a4fe" + "";
};